import React, { useContext, useEffect, useState } from 'react';
import { AuthRoutes, RouteNames } from '../../enums/RouteEnums';
import { AppContext } from '../../AppContext';
import { IMembership, useMembershipQuery } from '../../generated/graphql';
import { Actions } from '../../enums/ActionEnums';
import { useLocation, useNavigate } from 'react-router-dom';
import { AssignmentInd, HomeWork, ImportContacts, Info, Receipt } from '@mui/icons-material';
import Loader from '../Common/Loader';
import OverviewToolbar from '../Common/Layout/OverviewToolbar';
import CompaniesTab from './InfoTabs/MembershipCompaniesTab';
import TabPanel from '../Common/Layout/TabPanel';
import { Box } from '@mui/material';
import CustomAppBar from '../Common/Layout/CustomAppBar';
import MembershipContactsTab from './InfoTabs/MembershipContactsTab';
import MembershipDetailsTab from './InfoTabs/MembershipDetailsTab';
import MembershipInvoicesTab from './InfoTabs/MembershipInvoicesTab';

const MembershipInfoWrapper: React.FunctionComponent = () => {
  const location = useLocation();
  const history = useNavigate();
  const { dispatch, state } = useContext(AppContext);

  const [membership, setMembership] = useState<IMembership | null>(null);
  const [value, setValue] = useState(0);

  const locationElements = location.pathname.split('/').filter((e) => e);
  const { data } = useMembershipQuery({
    variables: {
      id: parseInt(locationElements[locationElements.length - 1])
    },
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (data && data.result) {
      dispatch({
        type: Actions.SetSelectedMembership,
        payload: {
          id: data.result.id,
          name: data.result.name,
          start_date: data.result.start_date ?? null,
          end_date: data.result.end_date ?? null
        }
      });
      setMembership(data.result as IMembership);
    }
  }, [data]);

  const handleToMembershipsOverview = () => {
    dispatch({ type: Actions.ResetSelectedMembership });
    history(AuthRoutes.Memberships);
  };

  const handleChange = (_: unknown, newValue: number) => {
    setValue(newValue);
  };

  const updateCommentsCount = (isRemoved: boolean) => {
    const currentMembership = membership as IMembership;
    if (isRemoved) {
      setMembership({
        ...currentMembership,
        comments_count: currentMembership.comments_count - 1
      });
    } else {
      setMembership({
        ...currentMembership,
        comments_count: currentMembership.comments_count + 1
      });
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <OverviewToolbar
        handleToOverview={handleToMembershipsOverview}
        navName={RouteNames.Memberships}
      >
        <Box className="centralize">
          <AssignmentInd sx={{ marginRight: '7px' }} />
          {state.selectedMembership?.name || membership?.name}
        </Box>
      </OverviewToolbar>
      <Box>
        <CustomAppBar
          value={value}
          handleChange={handleChange}
          tabProps={[
            { id: 'membership-details', title: 'Details', icon: Info },
            { id: 'membership-companies', title: 'Companies', icon: HomeWork },
            { id: 'membership-contacts', title: 'Contacts', icon: ImportContacts },
            { id: 'membership-invoices', title: 'Invoices', icon: Receipt }
          ]}
        />
        {membership ? (
          <Box>
            <TabPanel value={value} index={0}>
              <MembershipDetailsTab
                membership={membership}
                updateCommentsCount={updateCommentsCount}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <CompaniesTab membershipId={parseInt(membership.id)} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <MembershipContactsTab membershipId={parseInt(membership.id)} />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <MembershipInvoicesTab membershipId={parseInt(membership.id)} />
            </TabPanel>
          </Box>
        ) : (
          <Loader loading={true} />
        )}
      </Box>
    </Box>
  );
};

export default MembershipInfoWrapper;
